<template>
  <div>
    <div class="bar_wrapper" ref="bar_wrapper">
      <div
        ref="bar"
        class="bar"
        :class="[tagGoodJobZone.length > 5 ?  'has_more' : '', requestCount ? 'show' : '']"
        :style="{
          backgroundColor: bgColor
        }"
      >
        <div class="box" ref="swiperbox">
          <div class="swiper">
            <div class="swiper-wrapper" :style="`color: ${tagColor};`">
              <div class="swiper-slide"
                v-for="(item, index) in tagGoodJobZone"
                :class="{on: tagIndex == index}"
                :style="{backgroundColor: tagIndex == index ? tagColor : ''}"
                :key="index"
                @click="jumpToBlock(index, item.pageTitle)"
              >
              {{ item.pageTitle }}
              <em :style="`border-top-color: ${tagColor};`"></em>
              </div>
            </div>
          </div>
        </div>

        <div class="list" :class="{show: isMore == true}">
          <div class="in">
            <p class="title">全部专区</p>
            <ul>
              <li v-for="(item, index) in tagGoodJobZone" :key="index"><span @click="jumpToBlock(index)" :class="{on: tagIndex == index}">{{ item.pageTitle }}</span></li>
            </ul>
          </div>
        </div>

        <div class="more" :style="`background-color:`+moreTagBg" @click="showMore">
          <span :style="`background-image: linear-gradient(to right, rgba(255, 255, 255, 0), ${moreTagBg});`"></span>
          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="none" version="1.1" width="16" height="16" viewBox="0 0 16 16"><g><g></g><g><path d="M2,2.75C2,2.335786,2.335786,2,2.75,2L13.25,2C13.6642,2,14,2.335786,14,2.75L14,2.75C14,3.1642099999999997,13.6642,3.5,13.25,3.5L2.75,3.5C2.335786,3.5,2,3.1642099999999997,2,2.75L2,2.75ZM2,8C2,7.58579,2.335786,7.25,2.75,7.25L13.25,7.25C13.6642,7.25,14,7.58579,14,8L14,8C14,8.41421,13.6642,8.75,13.25,8.75L2.75,8.75C2.335786,8.75,2,8.41421,2,8L2,8ZM2,13.25C2,12.8358,2.335786,12.5,2.75,12.5L13.25,12.5C13.6642,12.5,14,12.8358,14,13.25L14,13.25C14,13.6642,13.6642,14,13.25,14L2.75,14C2.335786,14,2,13.6642,2,13.25L2,13.25Z" :fill="tagColor" fill-opacity="1"/></g></g></svg>
        </div>
      </div>
    </div>

    <div ref="comRefs" v-for="(item, index) in goodJobZone" :key="index">
      <UrgentRecruitmentCompany
        :pageConfig="pageConfig"
        :componentConfig="componentConfig"
        :goodJobZone="item"
        :goodRank ="index"
        :goodJobZoneLength= "goodJobZone.length"
        :componentType="2"
        @updateGoodList="updateGoodList"
        v-on="$listeners"
      />
    </div>
    <van-overlay :show="isMore" @click="isMore = false" z-index="9" />
  </div>
</template>

<script>
import { mapState } from "vuex";
import UrgentRecruitmentCompany from "../UrgentRecruitmentCompany";
import Swiper from 'swiper';
import 'swiper/css/swiper.min.css';

export default {
  name: "GoodsBlock",
  components: { UrgentRecruitmentCompany },
  props: {
    pageConfig: {
      type: Object,
      default: () => {},
    },
    componentConfig: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      swiper: null,
      goodJobZone: [],
      tagGoodJobZone: [],
      requestCount: 0,
      bgColor: '',
      paddingTop: 0,
      stateHeight: 0,
      tagColor: this.componentConfig.goodJobComponentDTO.zoneBackgroundColor,
      tagIndex: 0,
      rectsTop: [],
      isScroll: false,
      isMore: false,
      moreTagBg: this.pageConfig.backgroundColor,
      isFirstInit:false,
    }
  },
  computed: {
     ...mapState(["commonStore"]),
    barTop() {
      return 44 + this.stateHeight - 1;
    },
    barHeight() {
      return 54 + this.barTop;
    }
  },
  watch:{
    "commonStore.currentAreaCode": {
      handler(val) {
        this.slideReset();
      },
      immediate: false,
    },
    "commonStore.deweightComponentSort":{//监控去重顺序变更
      handler(val) {
        if(val == this.componentConfig.deWeightSort){
          console.log("触发好职专区主专区")
          this.isFirstInit = true;
          if(this.goodJobZone.length > 0){//电梯专区拿到值的时候触发
            this.$nextTick(()=>{
              this.$store.commit("setValue", {//触发监控顺序加载变量
                deweightComponentSort: this.componentConfig.deWeightSort + '-0',
              });
            });
          }
        }
      },
      immediate: false,
    },
    goodJobZone:{
      handler(val) {
        if(this.isFirstInit){
          this.isFirstInit = false;
          this.$nextTick(()=>{//好职首次加载时候触发
            this.$store.commit("setValue", {//触发监控顺序加载变量
              deweightComponentSort: this.componentConfig.deWeightSort + '-0',
            });
          });
        }
      },
      immediate: false,
    },
  },
  async mounted() {
    const res = await this.$api.activity.getGoodJobZone();
    if (res?.code == '0' && res?.data) {
      let goodJobZoneRange = this.componentConfig.goodJobComponentDTO.goodJobZoneRange;
      // goodJobZoneRange = [999001, 1, 2, 3, 4, 7, 23, 24, 25, 26] // 测试数据
      // goodJobZoneRange = [12, 21, 27, 31, 33, 48] // 测试数据
      let goodJobZone = this.findMatchingData(res.data, goodJobZoneRange);

      const material = await this.$api.activity.getGoodJobZoneMaterial();
      if (material?.code == '0' && material?.data) { // 获取专区顶部背景图片
        goodJobZone = goodJobZone.map((data) => {
          if (material.data[data.id]) {
            data.bcopBackgroundImg = material.data[data.id].bcopBackgroundImg || '';
          }
          return data;
        });
      }

      this.goodJobZone = [ ...goodJobZone ];
      this.tagGoodJobZone = [ ...goodJobZone ];

      if (this.goodJobZone.length) {
        if(this.$store.state.commonStore.searchPage){
          this.stateHeight = '0px'
        }else{
          this.stateHeight = await this.$base.getAppStateHeight();
        }
        this.stateHeight = parseInt(this.stateHeight);
        
        this.slideIni();

        window.addEventListener('scroll', this.handleScroll);
      }

    }
  },
  beforeDestroy() {
    try {
      window.removeEventListener('scroll', this.handleScroll);
    } catch(e) {}
  },
  methods: {
    findMatchingData(arrayOne, arrayTwo) {
        const idToObjectMap = {};
        arrayOne.forEach(item => {
          idToObjectMap[item.id] = item;
        });

        // 遍历数组二，根据映射查找匹配的数据
        const result = [];
        arrayTwo.forEach(id => {
          if (idToObjectMap[id]) {
            result.push(idToObjectMap[id]);
          }
        });

        return result;
    },
    slideIni() {
      this.swiper = new Swiper('.swiper', {
        slidesPerView: 'auto',
        freeMode: true,
        spaceBetween: 6,
      });

      this.$sensors.track("WidgetShow", {
        pagecode: `YC|${this.$route.params.pageId}|${this.componentConfig.sort}|${this.componentConfig.type}|joblist|${this.componentConfig.id}|${this.pageConfig.activityZoneId}`,
        $element_id: "sensor_bcop_tabs",
      });
    },
    slideReset() {
      this.requestCount = 0;
      this.tagIndex = 0;
      this.swiper.destroy();
      this.tagGoodJobZone = [ ...this.goodJobZone ];
      this.$nextTick(() => {
        this.slideIni();
      });
    },
    handleScroll() {
      const bar_wrapper = this.$refs.bar_wrapper;
      const bar = this.$refs.bar;
      const rect = bar_wrapper.getBoundingClientRect();
      const top = rect.top;

      if (top <= this.barTop) {
        this.bgColor = this.pageConfig.hideColor;
        this.moreTagBg = this.pageConfig.hideColor;
        bar.style.position = 'fixed';
        bar.style.top = this.barTop + 'px';
        bar.style.zIndex = 10;
      } else {
        this.bgColor = '';
        this.moreTagBg = this.pageConfig.backgroundColor;
        bar.style.position = 'relative';
        bar.style.top = '0';
        bar.style.zIndex = 0;
      }

      if (!this.isScroll) {
        let tagIndex = -1;
        const scrollTop =  document?.documentElement.scrollTop || document.body.scrollTop;
        this.rectsTop.map((item, index) => {
          const top = item - this.barHeight;
          if (scrollTop >= top) {
            tagIndex = index;
          }
        });

        if (tagIndex != -1) {
          this.tagIndex = tagIndex;

          this.adjustSwiperIndex();
        }
      }
    },
    adjustSwiperIndex() { // 矫正swiper，确保tag可见
      const box = this.$refs.swiperbox;
      const slide = box.querySelectorAll('.swiper-slide')[this.tagIndex];
      // 解决dom不存在时报错
      if(slide && slide.getBoundingClientRect()){
          const left = slide.getBoundingClientRect().left - box.getBoundingClientRect().left;
          if (left >= box.offsetWidth/2 || left <= box.offsetWidth/4) {
          const index = this.tagIndex > 1 ? this.tagIndex - 2 : 0;

          this.swiper.slideTo(index, 200, false);
        }
      }
    },
    scrollWait() { // 对scrollTo方法的“回调”处理
      if ('onscrollend' in window) {
        const wait = () => {
          window.removeEventListener('scrollend', wait)
          this.isScroll = false;
        }

        window.addEventListener('scrollend', wait)
      } else {
        setTimeout(() => {
          this.isScroll = false;
        }, 500)
      }

    },
    jumpToBlock(index, name='') { // 点击tag后跳转
      this.tagIndex = index;

      const id = this.tagGoodJobZone[index].id;
      index = this.goodJobZone.findIndex(item => item.id === id);

      if (name) {
        this.$sensors.track("$WebClick", {
          $element_id: "sensor_bcop_tabs",
          contentName: name,
          bcopExrinfo: {
            pagecode: `YC|${this.$route.params.pageId}|${this.componentConfig.sort}|${this.componentConfig.type}|joblist|${this.componentConfig.id}|${this.pageConfig.activityZoneId}`,
          },
        });
      }

      this.isScroll = true;
      this.isMore = false;

      window.scrollTo({
        top: this.rectsTop[index] - this.barHeight + 1,
        behavior:'smooth'
      });

      this.adjustSwiperIndex();
      this.scrollWait();
    },
    showMore() {
      if (this.tagIndex == 0) { // 跳转到第一个专区
        window.scrollTo({
          top: this.rectsTop[0] - this.barHeight + 1
        });
      }

      this.isMore = true;
    },
    getTagIndex(index) {
      const id = this.goodJobZone[index].id;
      return this.tagGoodJobZone.findIndex(item => item.id === id);
    },
    async updateGoodList(data) {
      this.updateComLocation();

      if (data.count) {
        this.requestCount++
      } else {
        const index = this.getTagIndex(data.index);

        this.tagGoodJobZone.splice(index, 1);
        this.swiper.updateSlides();
      }
    },
    updateComLocation() { // 更新专区距离页面顶部top值（专区点击更多后导致变化）
      const comArr = this.$refs.comRefs;
      const scrollTop =  document?.documentElement.scrollTop || document.body.scrollTop;
      if (comArr) {
        const rectsTop = comArr.map((item) => {
          const top = item.getBoundingClientRect().top;

          return top + scrollTop;
        })

        this.rectsTop = rectsTop;
      }
    }
  }
}
</script>

<style scoped lang="less">
.bar_wrapper {
  height: 54px;
}

.bar {
  position: relative;
  width: 100%;
  height: 54px;
  padding-top: 11px;
  left: 50%;
  transform: translate3d(-50%, 0, 0);

  .swiper, .more {
    opacity: 0;
  }

  &.show {
    .swiper, .more {
      opacity: 1;
    }
  }

  .box {
    position: relative;
    height: 35px;
    overflow: hidden;
    z-index: 1;
  }

  .more {
    display: none;
    position: absolute;
    width: 25px;
    height: 40px;
    right: 0;
    top: 8px;
    z-index: 2;

    svg {
      position: relative;
      top: 6px;
    }

    span {
      position: absolute;
      width: 23px;
      height: 40px;
      top: 0;
      left: -20px;
    }
  }

  .list {
    display: none;
    position: absolute;
    width: 100%;
    font-weight: bold;
    font-size: 14px;
    color: #222;
    top: 0;
    left: 50%;
    transform: translate3d(-50%, 0, 0);
    z-index: 1000;

    &.show {
      display: block;
    }

    .in {
      background-color: #FFF;
      border-radius: 0 0 20px 20px;
    }

    .title {
      line-height: 17px;
      padding: 12px 16px 16px;
    }

    ul {
      padding: 0 10px 4px;

      li {
        float: left;
        width: 33%;
        padding: 0 6px 12px;
        box-sizing: border-box;

        span {
          display: block;
          line-height: 42px;
          text-align: center;
          cursor: pointer;
          background: #F2F4F7;
          border-radius: 21px;

          &.on {
            color: #FFF;
            background: linear-gradient(180deg, #FFB245 1%, #FF4E0E 99%);
          }
        }
      }

      li:nth-of-type(3n-1) {
        width: 34%;
      }

      &:after {
        display: block;
        content: '';
        clear: both;
      }
    }
  }

  &.has_more {
    .box {
      padding-right: 50px;
    }

    .more {
      display: flex;
    }
  }
}

.pc .bar {
  width: 10rem;
}

.swiper {
  .swiper-slide {
    display: inline-block;
    width: auto;
    line-height: 25px;
    height: 25px;
    font-size: 12px;
    text-align: center;
    padding: 0 8px;
    border-radius: 25px;
    background-color: #FFF;

    &:first-child {
      margin-left: 12px;
    }

    &.on {
      position: relative;
      color: #FFF;

      em {
        display: block;
        position: absolute;
        content: '';
        left: 50%;
        bottom: -6px;
        width: 0;
        height: 0;
        margin-left: -8px;
        border-style: solid;
        border-width: 8px;
        border-color: transparent;
        border-bottom: none;
      }
    }

    em {
      display: none;
    }
  }
}
</style>
